/**
 * KAN-811: доступность запроса к API текущему пользователю. Менеджеру (роль
 * MANAGER) открыт только список правил api_access из /auth/me, всем
 * остальным всё. Блоки и кнопки, чей запрос закрыт, не показываются, а их
 * запросы получают enabled: false, чтобы в консоли не было 403.
 */
import { useContext } from 'react';
import { QueryClientContext } from '@tanstack/react-query';
import { useCurrentUser, type CurrentUser } from '@/hooks/useCurrentUser';
import {
  canUserCallApi,
  isManagerUser,
  isPathAllowedForManager,
  type HttpMethod,
} from '@/lib/managerAccess';

export function useCanCallApi(method: HttpMethod, url: string): boolean {
  // Результат читается без деструктуризации: часть тестов подменяет
  // useCurrentUser пустым моком. Пользователь к этому моменту уже в кеше:
  // ManagerRouteGuard не рисует раскладку, пока /auth/me не загружен.
  const user = useCurrentUser()?.data;
  return canUserCallApi(user, method, url);
}

/**
 * Раздел кабинета открыт пользователю (менеджеру только из allow-list путей).
 * Пользователь берётся из кеша ['currentUser'] без подписки: его загружает
 * ManagerRouteGuard до раскладки. Так хук работает и вне QueryClientProvider
 * (общие компоненты сообщений в изолированных тестах): без кеша всё открыто.
 */
export function useCanOpenPath(pathname: string): boolean {
  const client = useContext(QueryClientContext);
  const user = client?.getQueryData<CurrentUser>(['currentUser']);
  return !isManagerUser(user) || isPathAllowedForManager(pathname);
}
